module.exports = __webpack_public_path__ + "img/fig15.f8a7756e.jpg";